import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/xushuichi_banner.png';
const _withScopeId = n => (_pushScopeId("data-v-f1932e08"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrap"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"web-banner\" data-v-f1932e08><img src=\"" + _imports_0 + "\" alt=\"\" data-v-f1932e08><div class=\"banner-word flex align-items\" data-v-f1932e08><h3 data-v-f1932e08>人力资源蓄水池</h3><h4 data-v-f1932e08>安徽省首个政府主导，爱沃客公司运营的专项精工技能人才培养项目</h4></div></div><div class=\"web-column column-info-common\" data-v-f1932e08><h3 data-v-f1932e08>我们的服务</h3><p data-v-f1932e08>安徽省首个政府主导的外引水、内调剂人力资源服务创新项目。</p><p data-v-f1932e08>以政府牵头搭建“政、企、校”三方合作，利用精细化合作模式与学校建立长期有效的人才储备机制，以定向人才培养实施人力资源“外引水”，以“引企入教”促进教育链、人才链与产业链、 创新链有机衔接，以专业共建和产业学院共建模式，通过定岗、双向、精准培养精益制造的工匠型人才，以精工带动普工形成人力资源 “蓄水池”，为企业提供人力资源支撑保障。</p><p data-v-f1932e08>2020年，受新冠疫情影响，合肥经济技术开发区“蓄水池”创新推出“共享用工”新模式，以共享用工实施人力资源“内调剂”，通过人员流转实现用工余缺调剂，促进人力资源合理调配。</p></div><div class=\"web-column2\" data-v-f1932e08><h1 data-v-f1932e08>核心业务</h1></div>", 3);
const _hoisted_5 = {
  class: "xu-business-list grey-bg"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"xu-b-intro\" data-v-f1932e08><h3 data-v-f1932e08>精工班</h3><p data-v-f1932e08>在提升学生文化课和专业课的同时，定制化培训企业文化、社会实践和职业规划等课程，帮助学生毕业后直接到企业高质量技能岗工作。</p></div><div class=\"xu-business-data row2 flex\" data-v-f1932e08><div class=\"b-data list\" data-v-f1932e08><h3 data-v-f1932e08><span data-v-f1932e08>20</span>家</h3><p data-v-f1932e08>入池企业</p></div><div class=\"b-data list\" data-v-f1932e08><h3 data-v-f1932e08><span data-v-f1932e08>88+</span></h3><p data-v-f1932e08>精工班</p></div><div class=\"b-data list\" data-v-f1932e08><h3 data-v-f1932e08><span data-v-f1932e08>3500+</span></h3><p data-v-f1932e08>精工人才</p></div><div class=\"b-data list\" data-v-f1932e08><h3 data-v-f1932e08><span data-v-f1932e08>10000+</span></h3><p data-v-f1932e08>输送普工</p></div></div>", 2);
const _hoisted_8 = {
  class: "busniess-banner jingGB-banner"
};
const _hoisted_9 = {
  href: ""
};
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = {
  class: "xu-business-list"
};
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"xu-b-intro\" data-v-f1932e08><h3 data-v-f1932e08>共享用工</h3><p data-v-f1932e08>针对不同企业的淡旺季，⽤⼈企业间签订共享协议，开展⽤⼯余缺调剂。共享⽤⼯模式取得较好的⼈⼒资源调剂效果。为常态化推进调节⼯作，促进⼈⼒资源合理调配，稳定劳动者就业岗位，合肥经济技术开发区决定成⽴“共享员⼯联盟”，这是合肥市⾸个共享员⼯联盟。</p><p data-v-f1932e08>2020年8⽉26⽇，合肥⾸个共享员⼯联盟在位于合肥经开区的中国合肥⼈⼒资源服务产业园正式成⽴。</p></div><div class=\"xu-business-data row2 flex\" data-v-f1932e08><div class=\"b-data list\" data-v-f1932e08><h3 data-v-f1932e08><span data-v-f1932e08>29</span>家</h3><p data-v-f1932e08>入盟企业</p></div><div class=\"b-data list\" data-v-f1932e08><h3 data-v-f1932e08><span data-v-f1932e08>37</span>批次</h3><p data-v-f1932e08>达成合作</p></div><div class=\"b-data list\" data-v-f1932e08><h3 data-v-f1932e08><span data-v-f1932e08>3434</span>人</h3><p data-v-f1932e08>共享用工</p></div><div class=\"b-data list\" data-v-f1932e08><h3 data-v-f1932e08><span data-v-f1932e08>90%</span></h3><p data-v-f1932e08>全市占比</p></div></div>", 2);
const _hoisted_14 = {
  class: "busniess-banner"
};
const _hoisted_15 = {
  href: "http://"
};
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = {
  class: "pool-SC-bg"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "入池企业与学校", -1));
const _hoisted_19 = {
  class: "pool-sc-logo"
};
const _hoisted_20 = ["src", "alt"];
const _hoisted_21 = ["src", "alt"];
const _hoisted_22 = {
  class: "web-column"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "联系我们", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "column-h2"
}, "专属顾问·一对一服务", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_header = _resolveComponent("top-header");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_van_config_provider = _resolveComponent("van-config-provider");
  const _component_contact_us = _resolveComponent("contact-us");
  const _component_bottom_foot = _resolveComponent("bottom-foot");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(() => [_createVNode(_component_top_header, {
      scenario: $data.scenario
    }, null, 8, ["scenario"])]),
    _: 1
  }), _hoisted_2, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_config_provider, {
    "theme-vars": $setup.themeVars
  }, {
    default: _withCtx(() => [_createVNode(_component_van_swipe, {
      class: "my-swipe",
      autoplay: 3000,
      "indicator-color": "#16A0F0"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataNewsJinggong, (item, key) => {
        return _openBlock(), _createBlock(_component_van_swipe_item, {
          key: key
        }, {
          default: _withCtx(() => [_createElementVNode("a", _hoisted_9, [_createElementVNode("img", {
            src: item.imageMax,
            alt: item.title
          }, null, 8, _hoisted_10), _createElementVNode("h3", null, _toDisplayString(item.title), 1)])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }, 8, ["theme-vars"])])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_14, [_createVNode(_component_van_config_provider, {
    "theme-vars": $setup.themeVars
  }, {
    default: _withCtx(() => [_createVNode(_component_van_swipe, {
      class: "my-swipe",
      autoplay: 3000,
      "indicator-color": "#16A0F0"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataNewsShare, (item, key) => {
        return _openBlock(), _createBlock(_component_van_swipe_item, {
          key: key
        }, {
          default: _withCtx(() => [_createElementVNode("a", _hoisted_15, [_createElementVNode("img", {
            src: item.imageMax,
            alt: item.title
          }, null, 8, _hoisted_16), _createElementVNode("h3", null, _toDisplayString(item.title), 1)])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }, 8, ["theme-vars"])])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataAdQiye, (item, key) => {
    return _openBlock(), _createElementBlock("div", {
      class: "logo",
      key: key
    }, [_createElementVNode("img", {
      src: item.imageUrl,
      alt: item.qname
    }, null, 8, _hoisted_20)]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataAdSchool, (item, key) => {
    return _openBlock(), _createElementBlock("div", {
      class: "logo",
      key: key
    }, [_createElementVNode("img", {
      src: item.imageUrl,
      alt: item.qname
    }, null, 8, _hoisted_21)]);
  }), 128))])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _hoisted_24, _createVNode(_component_contact_us, {
    scenario: $data.scenario
  }, null, 8, ["scenario"])]), _createVNode(_component_bottom_foot)]);
}